import SmartTable from './smart-table';
import './smart-table.scss';

export default SmartTable;
